import useSWR from 'swr';
import { SwrReturnType } from '~/models/Api';
import { DealCompletionReportImage } from '~/models/DealReportImage';

const paths = {
  index: '/deals/:deal_id/deal_completion_report_images'
};

type TIndex = (id: number | null) => SwrReturnType<DealCompletionReportImage[]>;
type ReturnType = {
  index: TIndex;
};

export const useDealCompletionReportImages = (): ReturnType => {
  const index: TIndex = (dealId: number | null) => {
    const { data, mutate, error } = useSWR<DealCompletionReportImage[]>(
      dealId === null ? null : paths.index.replace(':deal_id', String(dealId))
    );
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
